export const TRANSACTION_STATUS = {
  completed: 'primary',
  pending: 'pending',
  failed: 'canceled',
  reversed: 'gray',
};
